module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/updation-applicant-details/updation-applicant-form/updation-applicant-form.component.css
// module id = ./src/app/applicant/updation-applicant-details/updation-applicant-form/updation-applicant-form.component.css
// module chunks = main